import { useLoginState } from '#src/app/shared/hooks/session';
import { canSavePaymentMethod } from '#src/app/shared/utils/payments';

export function useCanSavePaymentMethod(doubleOptinEnabledNewUser: boolean): boolean {
	return canSavePaymentMethod(useLoginState(), doubleOptinEnabledNewUser);
}
